export default (array: { created_at?: string; [key: string]: any }[]) => {
  return array.sort(
    (a: any, b: any) => (new Date(a.created_at) as any) - (new Date(b.created_at) as any),
  );
};
